module.exports = __webpack_public_path__ + "img/look-coupon.ea194f1b.png";